import { useCallback } from 'react';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackNewsItemExposureEventData } from './legacy-types';

export const createLegacyTrackNewsItemExposure = (
  id: string,
  name: string,
): LegacyTrackNewsItemExposureEventData => {
  const eventData: LegacyTrackNewsItemExposureEventData = {
    eventType: 'newsItemExposure',
    newsItemId: id,
    newsItemName: name,
  };

  return eventData;
};

export const useLegacyTrackNewsItemExposure = () => {
  const { track } = useLegacyTracking();

  const trackLegacyNewsItemExposure = useCallback(
    (id: string, name: string) => {
      track({
        event: 'newsItemExposure',
        data: createLegacyTrackNewsItemExposure(id, name),
      });
    },
    [track],
  );

  return {
    trackLegacyNewsItemExposure,
  };
};
